import { Typography } from "@mui/material";
import { PieChart, Pie, Cell, Legend, Tooltip } from "recharts";

// Match colors by PriorityName
const COLOR_MAP = {
  High: "#FFCC33",
  Low: "#1876D5",
  Normal: "#7EB341",
  Urgent: "#F04630",
  Hot: "#FF9704",
};

export default function DonutChart({ priority = [] }) {
  if (!Array.isArray(priority) || priority.length === 0) {
    return (
      <div className="flex flex-col items-center justify-center p-6">
        <Typography variant="h6" align="center">
          No priority data available
        </Typography>
      </div>
    );
  }

  const chartData = priority.map((item) => ({
    name: item.prorityname,
    value: item.leadCount,
  }));

  return (
    <div className="flex flex-col items-center justify-center ">
      {/* <Typography variant="h5" align="center" gutterBottom>
        Leads Priority
      </Typography> */}
      <PieChart width={400} height={300}>
        <Pie
          data={chartData}
          innerRadius={50}
          outerRadius={90}
          paddingAngle={3}
          dataKey="value"
        >
          {chartData.map((entry, index) => (
            <Cell
              key={`cell-${index}`}
              fill={COLOR_MAP[entry.name] || "#8884d8"}
            />
          ))}
        </Pie>
        <Tooltip formatter={(value) => `${value}`} />
        <Legend
          layout="horizontal"
          align="center"
          verticalAlign="bottom"
          wrapperStyle={{ paddingTop: 10 }}
        />
      </PieChart>
    </div>
  );
}
